/**
 * Resolutions / refund method column: no-offers warning and resolution label.
 */
import { observer } from "mobx-react";
import { useMemo } from "react";
import FontBody1 from "../../../../../components/fonts/font-body1/font-body1";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import IconWarning from "../../../../../components/icons/icon-warning/icon-warning";
import { TOOLTIP_VARIANTS, Tooltip } from "../../../../../components/tooltip/tooltip";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import RmaListItemStore from "../../../rma-list-page/stores/rma-item-store";
import "./table-column-resolutions.scss";

export interface ITableColumnResolutionsProps {
    rma: RmaListItemStore;
}

const TableColumnResolutions: React.FC<ITableColumnResolutionsProps> = observer(({ rma }) => {
    const scope = "dashboard-returns-page";
    const { getTranslation } = useDashboardTranslation();
    const noOffersIcon = useMemo(() => {
        if (!rma.noOffers) {
            return null;
        }
        if (rma.noOffers > 0) {
            const title =
                rma.noOffers === rma.amount ? getTranslation("NO_OFFERS_NOTE_1", scope) : getTranslation("NO_OFFERS_NOTE_2", scope);
            return (
                <Tooltip
                    variant={TOOLTIP_VARIANTS.WARNING}
                    content={
                        <FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                            <div className="table-column-resolutions__nooffer-tooltip">{title}</div>
                        </FontBody2>
                    }
                >
                    <IconWarning color="var(--color-semantic-warning)" />
                </Tooltip>
            );
        }
    }, [getTranslation, rma.noOffers, rma.amount]);
    const showResolutionName = !rma.noOffers || rma.noOffers !== rma.amount;
    return (
        <div className="table-column-resolutions">
            {noOffersIcon}
            <FontBody1>{showResolutionName && rma.resolutionName}</FontBody1>
        </div>
    );
});

export default TableColumnResolutions;
